import React, { useRef } from 'react';
import { CLANS } from '../../config/clans';

interface ClanSelectorProps {
  onSelect: (clanId: string) => void;
}

const ClanSelector: React.FC<ClanSelectorProps> = ({ onSelect }) => {
  const scrollContainerRef = useRef<HTMLDivElement>(null);

  const scroll = (direction: 'left' | 'right') => {
    if (scrollContainerRef.current) {
      // Прокручиваем ровно на ширину одной карточки (100% ширины контейнера)
      const containerWidth = scrollContainerRef.current.offsetWidth;
      const newScrollLeft =
        direction === 'left'
          ? scrollContainerRef.current.scrollLeft - containerWidth
          : scrollContainerRef.current.scrollLeft + containerWidth;

      scrollContainerRef.current.scrollTo({
        left: newScrollLeft,
        behavior: 'smooth'
      });
    }
  };

  return (
    <div className="relative w-full max-w-md mx-auto group"> {/* Ограничили ширину контейнера */}

      {/* Кнопка Назад */}
      <button
        onClick={() => scroll('left')}
        className="absolute left-2 top-1/2 -translate-y-1/2 z-20 bg-black/60 hover:bg-blue-600 text-white p-2 rounded-full backdrop-blur-sm transition-all opacity-0 group-hover:opacity-100 border border-white/10 shadow-lg"
      >
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2.5} stroke="currentColor" className="w-5 h-5">
          <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 19.5L8.25 12l7.5-7.5" />
        </svg>
      </button>

      {/* Контейнер слайдера */}
      <div
        ref={scrollContainerRef}
        className="flex overflow-x-auto snap-x snap-mandatory scrollbar-hide scroll-smooth w-full"
        style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}
      >
        {CLANS.map((clan) => (
          <button
            key={clan.id}
            type="button"
            onClick={() => onSelect(clan.id)}
            // w-full заставляет карточку занять всю доступную ширину
            // h-[200px] делает её достаточно высокой для контента
            className="snap-center shrink-0 w-full h-[200px] relative overflow-hidden rounded-2xl p-6 text-left transition-transform duration-300 active:scale-[0.98] border border-white/10 shadow-2xl cursor-pointer select-none"
            style={{ background: clan.gradient }}
          >
            <div className="absolute inset-0 bg-black/10 hover:bg-transparent transition-colors" />

            <div className="relative z-10 flex flex-col h-full justify-between pointer-events-none">
              <div className="flex items-start gap-5">
                <span className="text-6xl filter drop-shadow-lg">{clan.emoji}</span>
                <div className="pt-1">
                  <h3 className="text-white font-black text-2xl uppercase tracking-wide drop-shadow-md">
                    {clan.name}
                  </h3>
                  <p className="text-white/90 text-base mt-2 leading-relaxed font-medium drop-shadow-sm">
                    {clan.description}
                  </p>
                </div>
              </div>

              <div className="flex justify-end items-center gap-2">
                <span className="text-xs text-white/50 uppercase tracking-widest">Клан</span>
                <div
                  className="w-4 h-4 rounded-full shadow-[0_0_15px_currentColor] animate-pulse"
                  style={{ backgroundColor: clan.auraColor, color: clan.auraColor }}
                />
              </div>
            </div>
          </button>
        ))}
      </div>

      {/* Кнопка Вперед */}
      <button
        onClick={() => scroll('right')}
        className="absolute right-2 top-1/2 -translate-y-1/2 z-20 bg-black/60 hover:bg-blue-600 text-white p-2 rounded-full backdrop-blur-sm transition-all opacity-0 group-hover:opacity-100 border border-white/10 shadow-lg"
      >
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2.5} stroke="currentColor" className="w-5 h-5">
          <path strokeLinecap="round" strokeLinejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
        </svg>
      </button>

    </div>
  );
};

export default ClanSelector;